import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const CHANGE_ORDERS_URL = `${API_URL}/change-orders`;

const getAuthToken = () => localStorage.getItem('token');

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`
  }
});

export const createChangeOrder = async (payload) => {
  const response = await axios.post(CHANGE_ORDERS_URL, payload, getHeaders());
  return response.data;
};

export const fetchChangeOrders = async (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') queryParams.append(key, value);
  });
  const response = await axios.get(`${CHANGE_ORDERS_URL}?${queryParams.toString()}`, getHeaders());
  return response.data;
};

export const fetchChangeOrderById = async (id) => {
  const response = await axios.get(`${CHANGE_ORDERS_URL}/${id}`, getHeaders());
  return response.data;
};

export const updateChangeOrder = async (id, payload) => {
  const response = await axios.put(`${CHANGE_ORDERS_URL}/${id}`, payload, getHeaders());
  return response.data;
};

export const deleteChangeOrder = async (id) => {
  const response = await axios.delete(`${CHANGE_ORDERS_URL}/${id}`, getHeaders());
  return response.data;
};

export const sendChangeOrder = async (id) => {
  const response = await axios.post(`${CHANGE_ORDERS_URL}/${id}/send`, {}, getHeaders());
  return response.data;
};

export const approveChangeOrder = async (id) => {
  const response = await axios.post(`${CHANGE_ORDERS_URL}/${id}/approve`, {}, getHeaders());
  return response.data;
};

export const declineChangeOrder = async (id) => {
  const response = await axios.post(`${CHANGE_ORDERS_URL}/${id}/decline`, {}, getHeaders());
  return response.data;
};

export const getChangeOrderPublicUrl = (token) => {
  return `https://crm.mrpatchasphalt.com/change-order/${token}`;
};
